import { Box } from '@mui/material';
import { Dialog, Loading } from 'common/components';

type ReconnectingModalProps = {
  isOpen: boolean;
};

export const ReconnectingModal = ({ isOpen }: ReconnectingModalProps) => (
  <Dialog
    isOpen={isOpen}
    title="Reconnecting"
    description="Connection to server lost. Reconnecting..."
    showCancelButton={false}
    showCloseButton={false}
    disableClickOutside
  >
    <Box py={2}>
      <Loading />
    </Box>
  </Dialog>
);
